import React from 'react';
import { motion } from 'framer-motion';
import { FaGithub, FaLinkedin, FaTwitter, FaEnvelope } from 'react-icons/fa';  
import '../Styles/Contact.css';

const Contact = () => {
  return (
    <motion.section
      className="contact-page"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >
      {/* Background Animation */}
      <div className="background-animation"></div>

      {/* Content Section */}
      <div className="contact-content">
        <motion.h2
          className="main-heading"
          initial={{ x: -100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 1, delay: 0.5 }}
        >
          Let's Connect!
        </motion.h2>

        <motion.p
          className="sub-heading"
          initial={{ x: 100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 1, delay: 0.7 }}
        >
          Reach out to me for collaborations, new projects, or just to say hello.
        </motion.p>

        <div className="icon-buttons">

          <motion.a
            href="https://www.linkedin.com/in/nadeem-ashraf-99a064205/"
            target="_blank"
            rel="noopener noreferrer"
            className="icon-button"
            whileHover={{ scale: 1.2 }}
            whileTap={{ scale: 0.9 }}
          >
            <FaLinkedin />
          </motion.a>

          <motion.a
            href="mailto:na216904@gmail.com"
            target="_blank"
            rel="noopener noreferrer"
            className="icon-button"
            whileHover={{ scale: 1.2 }}
            whileTap={{ scale: 0.9 }}
          >
            <FaEnvelope />
          </motion.a>
        </div>
      </div>
    </motion.section>
  );
};

export default Contact;
